import { SAVR_USER_INFO, DELETE_USER_INFO } from '../action_types'
import { meshLog, SPRemove, SPGet, SPSet } from '../../utils/spUtils'

let token = SPGet('token')
let email = SPGet('email')
let name = SPGet('name')
let initState = {
    token: token || '',
    isLogin: token ? true : false,
    email: email || '',
    name: name || ''
}

export default function test(perState = initState, action) {
    // meshLog('被调用了');
    const { type, date } = action
    let newState
    switch (type) {
        case SAVR_USER_INFO:
            //newState = { meshList: date.meshList, token: date.token, isLogin: true, email: date.email, name: date.name, }
            newState = { token: date.token, isLogin: true, email: date.email, name: date.name, }
            return newState
        case DELETE_USER_INFO:
            //newState = { meshList: '', token: '', isLogin: false, email: '' }
            newState = { token: '', isLogin: false, email: '' }
            return newState
        default:
            return perState
    }

}
